const ROLE_TYPES = {
  ADMIN: 'Admin',
  SUPER_ADMIN: 'Super_Admin',
  SUPER_ADMIN_SECOND: 'super_admin',
  TEACHER: 'Teacher',
  STUDENT: 'Student'
};

export default ROLE_TYPES;
